// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  defaultAdb2cTemplate: 'business-dev',
  myInvitationBaseUrl: "/my-invitation",
  registerBaseUrl: "/register",
  rootDomain: 'skeddle.com',
  defaultTenant: 'business-dev',
  appInsights: {
    instrumentationKey: "e76179ac-33d9-45bd-bd5a-801942886af0",
    applicationName: 'skeddle-business-dev'
  },
  sentryDsn: "https://0a9659f2089bfd27a5a55d9c9ffdac43@o4508941675855873.ingest.de.sentry.io/4508942125170768",
  domainHint: null,
  ssoSubDomains: [
      'howden'
  ],
  ssoClientId: '4f03554d-f015-4e3e-ac6c-7eaf29680da6'
};

/**
 * This file contains authentication parameters. Contents of this file
 * is roughly the same across other MSAL.js libraries. These parameters
 * are used to initialize Angular and MSAL Angular configurations in
 * in app.module.ts file.
 */

import {LogLevel, Configuration, BrowserCacheLocation} from '@azure/msal-browser';

const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig: Configuration = {
    auth: {
        clientId: '9d72496d-aa51-4cee-a932-32afaf57fc21', // This is the ONLY mandatory field that you need to supply.
        authority: 'https://skeddleexternaldev.ciamlogin.com/', // Replace the placeholder with your tenant subdomain
        // authority: b2cPolicies.authorities.signUpSignIn.authority, // Defaults to "https://login.microsoftonline.com/common"
        redirectUri: '/', // Points to window.location.origin. You must register this URI on Azure portal/App Registration.
        postLogoutRedirectUri: '/', // Indicates the page to navigate after logout.
        navigateToLoginRequestUrl: true, // If "true", will navigate back to the original request location before processing the auth code response.
    },
    cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage, // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: isIE, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback(logLevel: LogLevel, message: string) {
                // console.log(message);
            },
            logLevel: LogLevel.Verbose,
            piiLoggingEnabled: false
        }
    }
}

/**
 * Add here the endpoints and scopes when obtaining an access token for protected web APIs. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const protectedResources = {
    scopes: ["api://ef10d169-2e8a-4550-a8c3-ee1e270f552a/access_as_user"]
}
